import { motion } from "framer-motion";

export default function SectionHeader({ eyebrow, title, italic, sub, align = "left", testId }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
      data-testid={testId}
    >
      {eyebrow && (
        <div className="text-[11px] tracking-[0.3em] uppercase font-semibold text-[var(--gold)] flex items-center gap-3">
          <span className="inline-block w-8 h-px bg-[var(--gold)]" /> {eyebrow}
        </div>
      )}
      <h2 className="font-serif-display mt-5 text-4xl md:text-5xl lg:text-6xl text-[var(--ink)]">
        {title}
        {italic && <> <span className="font-serif-italic text-[var(--gold)]">{italic}</span></>}
      </h2>
      {sub && (
        <p className="mt-5 text-[var(--slate-1)] text-base sm:text-lg leading-relaxed max-w-2xl">
          {sub}
        </p>
      )}
    </motion.div>
  );
}
